import { useMemo } from 'react';
import { validateContent, isValidContentShape, type ValidationError } from '@capture/shared';
import { useFormConfigStore } from '../state/store';

/**
 * Returns ValidationError[] from `validateContent(content)` filtered to a
 * single destination's `routingCondition` path. Mirrors the shape of
 * `useFieldValidator` (form-config-side per-field validator hook).
 */
export function useDestinationValidator(destinationId: string): ValidationError[] {
  const content = useFormConfigStore((s) => s.content);
  return useMemo(() => {
    if (!isValidContentShape(content)) return [];
    return validateContent(content).filter(
      (err) =>
        err.path[0] === 'export' &&
        err.path[1] === 'destinations' &&
        err.path[2] === destinationId &&
        err.path[3] === 'routingCondition',
    );
  }, [content, destinationId]);
}
